module.exports = {
          srcSet: "/_next/static/images/img-mobilier@2x-160-202427185ac75092a734e47c86e06349.jpg"+" 160w"+","+"/_next/static/images/img-mobilier@2x-292-fb01194ff7f290aec999f8de7dc57001.jpg"+" 292w",
          images:[ {path: "/_next/static/images/img-mobilier@2x-160-202427185ac75092a734e47c86e06349.jpg",width: 160,height: 137},{path: "/_next/static/images/img-mobilier@2x-292-fb01194ff7f290aec999f8de7dc57001.jpg",width: 292,height: 250}],
          src: "/_next/static/images/img-mobilier@2x-160-202427185ac75092a734e47c86e06349.jpg",
          toString:function(){return "/_next/static/images/img-mobilier@2x-160-202427185ac75092a734e47c86e06349.jpg"},
          placeholder: undefined,
          width: 160,
          height: 137
      }